import ProfileFirstBlock from '../../../js/components/Profile/profileFirstBlock.js';

export default ProfileFirstBlock;
